import { AlertCircle, Check, CheckCheck, Clock, FileText } from 'lucide-react';

import type { MessageApi } from '@/modules/messaging/types';

const ICON_SIZE = 13;

const MESSAGE_ICON = {
  Sent: <Check size={ICON_SIZE} />,
  Read: <CheckCheck size={ICON_SIZE} color="#1890ff" />,
  Pending: <Clock size={ICON_SIZE} />,
  Draft: <FileText size={ICON_SIZE} />,
  Failed: <AlertCircle size={ICON_SIZE} color="#ff4d4f" />,
} as const;

export const MessageStatusIcon = ({
  status,
}: {
  status: NonNullable<MessageApi['status']>;
}) => {
  return MESSAGE_ICON[status];
};
